module.exports = __webpack_public_path__ + "static/media/activity-black.09675d6a.svg";